export default __webpack_public_path__ + "static/media/beispiel-versicherungskarte.e7014f71.png";